import styled from 'styled-components';
import {
  TableContainer
} from 'cdk-radial';

export const StyledTableContainer = styled(TableContainer)`
  left: 0px;

`;

export const StyledLongDescCount = styled.div`
  margin-top:3px;
  font-family:Roboto, sans-serif;
  font-weight:400;
  display:flex;
  justify-content:end;
`;

export const StyledCustomEditorLabel = styled.div`
   font-family:Roboto, sans-serif;
   font-size:1rem;
   color:${({ theme }) => (theme.darkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)')}; 
`;

export const StyledCountLabel = styled.span`
   color:${({ theme }) => (theme.darkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)')}; 
  font-size: 0.75rem
`;

export const StyledTableWrapper = styled.div<{ hideHeader:boolean }>`
  width: 100%;
  height: 60vh !important;

  .ag-root-wrapper {
    border: none !important;
  }

  .ag-pivot-off .ag-header-cell {
    font-size: 17px;
  }

  .ag-cell-wrapper{
    overflow: hidden;
  }

  .ag-menu-option{
    color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
  }

  .ag-icon{
    color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
  }

  .ag-tabs-header{
      background-color: ${({ theme }) => (theme.darkMode ? '#1A1A1A' : '#f2f2f2')};
  }
  .ag-menu-header{
      background-color: ${({ theme }) => (theme.darkMode ? '#1A1A1A' : '#f2f2f2')};
  }

  .ag-column-select-column-label{
    color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
  }

  .ag-header-row{
    height: 36px;
  }

  .ag-paging-panel{
     background-color: ${({ theme }) => (theme.darkMode ? '#1A1A1A' : '#f2f2f2')};
     color: ${({ theme }) => (theme.darkMode ? '#f2f2f2' : '#1A1A1A')};
  } 
  .ag-row-group-leaf-indent {
    margin-left: 0px;
  }

.ag-header-cell-comp-wrapper{
  height: 37px !important;
}

@media (max-height: 850px) {
  height: 50vh !important;
}

@media (max-height: 710px) {
  height: 65vh !important;
}

@media (max-height: 610px) {
  height: 45vh !important;
}

.ag-root .ag-header {
  display: ${({hideHeader}) => (hideHeader ? 'none' : 'visible')};
}
`

export const StyledContainerWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const PulseMain = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px;
    height: 700p;
`
export const UniPulseMainTitle = styled.div`
    display: flex;
    position: relative;
    width:254;
    height:45px;
    border: 0px 0px 1px 0px;
    gap: 8px;
    top: 10px;
    font-family: Roboto;
    font-weight:450;
    font-size:24px;
`

export const UserLookFormFilters = styled.div`
    display: flex;
    flex-direction: row;

    [data-testid='pulse-user-input-wrapper'] {
      margin-right: 10px;
      width: 280px;
    }

    [data-testid='pulse-user-input-ip-wrapper'] {
      margin-right: 10px;
      width: 220px;
    }

    [data-testid='button-pulse-user-search'] {
      flex-shrink: 0;
    }
`
export const GroupPaneMain = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;  
  margin: 6px;
  flex: 1;
`

export const GroupTitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid ${({ theme }) => (theme.darkMode ? '#fff' : '#000')};
  padding-bottom: 8px;
`


export const CardList = styled.div`
  display: grid;
  column-gap: 90px;
  row-gap: 70px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  @media (min-width: 1440px) {
  }
`;

export const GroupTitle = styled.div`
  font-size: 18px;
  margin: 5px;
`

export const GroupBodyContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const GroupItemHeader = styled.div`
  border-bottom: 2px solid black;
  display: flex;
  justify-content: space-between;
  height: 20px;
  padding: 4px;
`

export const UserList = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
`
export const StyledDateRangePicker = styled.div`
position: relative;

&& .DayPicker{
transform: translateX(-18rem)}

@media(min-width: 786px){
&& .DayPicker{
transform: translateX(-14rem)}
}
  @media(max-width: 900px){
  && .DayPicker{
  transform: translateX(-18rem)
  }
  }
@media(min-width: 1200px){
&& .DayPicker{
transform: translateX(-10rem)}
}
  @media(max-width: 1600px){
  && .DayPicker{
  transform: translateX(-24rem)
  }
  }
`


